export const hasNullValue = (obj) => {
  for (let key in obj) {
    if (obj[key] === null) {
      return true;
    }
  }
  return false;
};
export const isJSONParsable = (str) => {
  if (typeof str !== "string") {
    return false;
  }
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
};
export const joinPhrasesUsingDash = (prefix, postfix) => {
  return `${prefix} - ${postfix}`;
};
export const checkIfContainsPath = (currentPathname, checkPathname) => {
  const defaultPathname = "/";
  if (checkPathname === defaultPathname) {
    return currentPathname === defaultPathname;
  }
  return currentPathname == null ? void 0 : currentPathname.includes(checkPathname);
};
export const SIDEBAR_COOKIE_NAME = "zrl-sidebar-state";
export const getSidebarStateFromCookie = () => {
  if (typeof document === "undefined") return false;
  const sidebarStateRegex = new RegExp(`(?:^|;\\s*)${SIDEBAR_COOKIE_NAME}=(true|false)`);
  const match = document.cookie.match(sidebarStateRegex);
  return match ? match[1] === "true" : void 0;
};
